var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruitFinalTablet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 32,
    viewBox: "0 0 130 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1481_10227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8305 24.2687L74.3667 22.1997L82.2289 11.9913L85.7279 14.9296L76.8305 24.2687ZM70.8739 25.1522C71.4126 24.5238 71.96 24.2316 72.5158 24.2754C73.0834 24.3057 73.6157 24.5294 74.1126 24.9467C74.5957 25.3524 74.8985 25.8298 75.021 26.3792C75.1553 26.9148 74.953 27.4968 74.4143 28.1252C73.899 28.7262 73.3517 29.0185 72.7724 29.0019C72.2048 28.9717 71.6794 28.7537 71.1963 28.348C70.6994 27.9308 70.3897 27.4475 70.2672 26.8982C70.1563 26.3352 70.3586 25.7532 70.8739 25.1522Z",
    fill: "#FF872D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6989 9.81872L73.6764 22.2107L76.8445 24.9152L87.9647 16.0354L80.6989 9.81872Z",
    fill: "#FF872D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6047,
    height: 1.68407,
    transform: "matrix(-0.126437 0.991975 -0.992298 -0.123876 85.2539 0.208496)",
    fill: "#FFF7D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6225,
    height: 1.67767,
    transform: "matrix(-0.62412 0.781329 -0.787599 -0.616188 90.5703 7.15576)",
    fill: "#FFF7D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.65102,
    height: 1.6673,
    transform: "matrix(-0.98952 0.144399 -0.147366 -0.989082 96.2871 12.5854)",
    fill: "#FFF7D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.7306,
    cy: 2.30898,
    rx: 1.06066,
    ry: 1.0497,
    fill: "#FF872D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.9415,
    cy: 15.7445,
    rx: 1.06066,
    ry: 1.0497,
    fill: "#FF872D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.0958,
    cy: 7.34608,
    rx: 1.06066,
    ry: 1.0497,
    fill: "#FF872D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7601 13.2267L85.9723 17.6354L82.7907 20.1547L77.6993 15.1162L78.7601 13.2267Z",
    fill: "#FFBA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0039 18.0562L80.4579 22.0442L79.3972 22.884L74.9423 19.9448L76.0039 18.0562Z",
    fill: "#FFBA87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1481_10227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitFinalTablet);
export default __webpack_public_path__ + "static/media/recruit_final_tablet.43dce6ee2b12aeafcb78c68d4d1e382a.svg";
export { ForwardRef as ReactComponent };